module.exports = __webpack_public_path__ + "img/blank_networth.d532e7ec.jpg";